var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"my-music-page"}},[_c('AddTrackForm',{staticClass:"c-max-w",on:{"uploaded":_vm.onTrackUploaded}}),_c('MyMusic',{ref:"myMusic",staticClass:"c-max-w"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }